<template>
  <div style="display: flex; flex-direction: column">
    <div class="red" style="display: flex; flex-direction: column">
      <el-input :value="lblReleaseState" :disabled="true" />
    </div>
    <div>
      <el-checkbox :value="cargoDoc.releaseReview===1" :disabled="true" style="margin-right: 6px;">{{ $t('SeaExport.DataSent') }}</el-checkbox>
      <el-checkbox :value="cargoDoc.payable" :disabled="true" style="margin-right: 6px;">{{ $t('SeaExport.Completed') }}</el-checkbox>
      <el-checkbox :value="cargoDoc.withhold" :disabled="true" style="margin-right: 0px;">{{ $t('SeaExport.CargoDetention') }}</el-checkbox>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'SeHbl2LblReleaseState',
  props: {
    cargoDoc: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      lblReleaseState: ''
    }
  },
  watch: {
    'cargoDoc.releaseState': {
      immediate: true,
      handler(newVal) {
        this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(newVal)
      }
    }
  }
}
</script>
